import { render, staticRenderFns } from "./addDocument.vue?vue&type=template&id=d7d68b0a&scoped=true&"
import script from "./addDocument.vue?vue&type=script&lang=js&"
export * from "./addDocument.vue?vue&type=script&lang=js&"
import style0 from "./addDocument.vue?vue&type=style&index=0&id=d7d68b0a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d7d68b0a",
  null
  
)

export default component.exports